/* @flow */
// @ts-nocheck
import React, { Component, } from 'react';
import { getRoomName, } from '../../../base/conference/functions';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { translate } from "../../../base/i18n/functions";
import { connect } from "react-redux";
import { MIKUTANO_API_PREF } from "../../../welcome/components/WelcomePage.web";
const axios = require('axios');
/**
 * Agenda react component.
 *
 * @class Agenda
 */
class Agenda extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            agenda: [],
            meetingTheme: '',
            agendaText: '',
            agendaPrevText: '',
            meetingTimeOut: 3600,
            visible: true,
            editing: false,
            isAlready15Remained: false,
            isAlready5Remained: false,
            reservationIsUpdated: false,
            isAlreadyRefreshed: false
        };
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.editAgenda = this.editAgenda.bind(this);
        this._handleChangeEvent = this._handleChangeEvent.bind(this);
        this.save = this.save.bind(this);
    }
    makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }
    toggleVisibility(event) {
        event.preventDefault();
        // console.warn("----------------=================== CLICKED", this.state.visible);
        this.setState({
            visible: !this.state.visible
        });
    }
    ;
    editAgenda(value) {
        this.setState({
            agendaText: value['value'],
            agendaPrevText: value['value'],
            editing: true
        });
    }
    save(event) {
        event.preventDefault();
        var text = this.state.agendaText;
        // console.error("---------------------------------------", text, this.state.agenda);
        if (this.state.agenda.indexOf(this.state.agendaPrevText) > -1) {
            var newAgendas = this.state.agenda.map(el => (el === this.state.agendaPrevText ? text : el));
        }
        else {
            if (text) {
                var newAgendas = this.state.agenda.concat(text);
            }
            else {
                var newAgendas = this.state.agenda;
            }
        }
        // var edited
        // console.error("QQQQQQQQQQQQQQQQQQQQQQQQQQQQqqqq, ", newAgendas);
        this.setState({
            agenda: newAgendas,
            editing: false
        });
        this.updateAgenda(newAgendas);
    }
    _handleChangeEvent(e) {
        const agendaText = '';
        this.setState({
            agendaText: e.target.value,
        });
    }
    fetchAgenda() {
        var RandomNumber = this.makeid(32);
        var uniqueUID = localStorage.getItem('userID');
        if (uniqueUID) {
        }
        else {
            localStorage.setItem('userID', RandomNumber);
            uniqueUID = RandomNumber;
        }
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json, text/plain'
            },
        };
        var data = new FormData();
        data.append('roomID', this.props.roomName);
        data.append('participantID', uniqueUID);
        axios.post(MIKUTANO_API_PREF + '/display_agenda', data, options)
            .then(response => response)
            .then(json => {
            // console.error("00000000000000000000000000000000009 = ", json['data'])
            this.setState({
                isLoaded: true,
                agenda: json['data']['meetingAgenda'] ?? [],
                meetingTimeOut: json['data']['timeRemained'] ?? '',
                meetingTheme: json['data']['meetingTitle'] ?? '',
                reservationIsUpdated: json['data']['theReservationIsUpdated'] ?? false
            });
            if (this.state.meetingTimeOut == 15 && this.state.isAlready15Remained == false) {
                this.timeMinOutDisplay15();
            }
            if (this.state.meetingTimeOut == 5 && this.state.isAlready5Remained == false) {
                this.timeMinOutDisplay5();
            }
            var isAlreadyRefreshed = sessionStorage.getItem('isAlreadyRefreshed');
            // console.log("============================", isAlreadyRefreshed ,this.state.reservationIsUpdated , this.state.isAlready5Remained);
            if (this.state.reservationIsUpdated && this.state.isAlready5Remained && !isAlreadyRefreshed) {
                this.forceRefresh();
            }
        })
            .catch(function (error) {
            this.setState({
                isLoaded: true,
                error,
            });
            // console.warn(error, "<===================================="); // Network Error
        });
    }
    updateAgenda(newAgendas) {
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json, text/plain'
            },
        };
        var data = new FormData();
        data.append('updatedAgendaList', JSON.stringify(newAgendas));
        data.append('roomID', this.props.roomName);
        axios.post(MIKUTANO_API_PREF + '/fetching_agenda', data, options)
            .then(response => response)
            .then(json => {
            console.error("UPDATED--------------------------- = ", json['data']);
            this.setState({
                isLoaded: true,
                agenda: json['data']['meetingAgenda'] ?? [],
                meetingTheme: json['data']['meetingTitle'] ?? ''
            });
        })
            .catch(function (error) {
            this.setState({
                isLoaded: true,
                error,
                agenda: []
            });
            console.warn(error, "<===================================="); // Network Error
        });
    }
    timeMinOutDisplay15() {
        confirmAlert({
            title: 'Alert',
            message: '15 Minutes have remained before this meeting end',
            buttons: [{
                    label: 'Ok',
                    onClick: () => {
                    }
                },],
            closeOnEscape: false,
            closeOnClickOutside: false,
            willUnmount: () => {
            },
            onClickOutside: () => {
            },
            onKeypressEscape: () => {
            }
        });
        this.setState({
            isAlready15Remained: true
        });
        var timeLeft = 10;
        var timerId = setInterval(countdown, 1000);
        function countdown() {
            if (timeLeft == -1) {
                clearTimeout(timerId);
                // window.location
                //     .replace("/");
            }
            else {
                console.log(timeLeft);
                timeLeft--;
            }
        }
    }
    timeMinOutDisplay5() {
        confirmAlert({
            title: 'Alert',
            message: '5 Minutes have remained before this meeting end',
            buttons: [{
                    label: 'Ok',
                    onClick: () => {
                    }
                },],
            closeOnEscape: false,
            closeOnClickOutside: false,
            willUnmount: () => {
            },
            onClickOutside: () => {
            },
            onKeypressEscape: () => {
            }
        });
        this.setState({
            isAlready5Remained: true
        });
        var timeLeft = 10;
        var timerId = setInterval(countdown, 1000);
        function countdown() {
            if (timeLeft == -1) {
                clearTimeout(timerId);
                // window.location
                //     .replace("/");
            }
            else {
                console.log(timeLeft);
                timeLeft--;
            }
        }
    }
    forceRefresh() {
        const room = window.location.href;
        sessionStorage.setItem('isAlreadyRefreshed', String(true));
        window.location
            .replace(room);
    }
    componentDidMount() {
        this.interval = setInterval(() => this.fetchAgenda(), 5000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    render() {
        const { error, isLoaded, agenda, meetingTheme, visible, editing, agendaText } = this.state;
        if (error) {
            // return <div>Error: {error.message}</div>;
            return null;
        }
        else if (!isLoaded) {
            // return <div>Loading...</div>;
            return null;
        }
        else {
            return (React.createElement("div", null,
                React.createElement("div", { className: 'theme', onClick: this.toggleVisibility },
                    React.createElement("div", { className: 'theme__message' },
                        React.createElement("h4", { title: { meetingTheme } },
                            " THEME: ",
                            meetingTheme,
                            " "))),
                visible ? React.createElement("div", { className: 'agenda' },
                    React.createElement("div", { className: 'agenda__header' },
                        React.createElement("div", null,
                            React.createElement("h6", { style: { color: 'white', textAlign: 'center' } }, "AGENDA ")),
                        React.createElement("div", { className: 'agenda__close' },
                            editing ?
                                React.createElement("span", { style: { marginRight: '10px', fontSize: '15px', fontWeight: 'bolder' }, onClick: () => this.setState({ editing: false }) }, "-") :
                                React.createElement("span", { style: { marginRight: '10px', fontSize: '15px', fontWeight: 'bolder' }, onClick: () => this.editAgenda({ value: '' }) }, "+"),
                            React.createElement("span", { onClick: this.toggleVisibility }, "X"))),
                    React.createElement("hr", null),
                    React.createElement("span", { className: 'agenda__message' },
                        agenda.length == 0 ? React.createElement("p", null, "No Meeting Agenda") : agenda.map(agenda => (React.createElement("p", { key: agenda, onClick: () => this.editAgenda({ value: agenda }) }, agenda))),
                        React.createElement("br", null),
                        editing ? React.createElement("div", null,
                            React.createElement("form", { onSubmit: this.save },
                                React.createElement("input", { name: 'agenda', value: agendaText, onChange: this._handleChangeEvent, type: 'text' }))) : ''))
                    : ''));
        }
    }
}
/**
 * Maps (parts of) the Redux state to the associated
 * {@code Agenda}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     roomName: string,
 * }}
 */
function _mapStateToProps(state) {
    var d = getRoomName(state);
    return {
        roomName: d
    };
}
export default translate(connect(_mapStateToProps)(Agenda));
